import { createBrowserRouter, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import DashboardModern from './pages/DashboardModern';
import Quotations from './pages/Quotations';
import SystemAdmin from './pages/admin/SystemAdmin';
import NotFound from './pages/NotFound';
import Login from './pages/Login';
import ProtectedRoute from './components/routing/ProtectedRoute';
import Customers from './pages/Customers';
import CustomerGroups from './pages/CustomerGroups';
import Suppliers from './pages/Suppliers';
import CustomerRelationshipLogs from './pages/CustomerRelationshipLogs';
import Products from './pages/Products';
import Categories from './pages/Categories';
import Settings from './pages/Settings';
import Deals from './pages/Deals';
import Users from 'pages/admin/Users';
import Organizations from 'pages/admin/Organizations';
import Contracts from 'pages/Contracts';
import { ProfilePage } from './components/profile/ProfilePage';
import SharedContractView from './pages/SharedContractView';
import SharedQuotationView from './pages/SharedQuotationView';
import Templates from 'pages/Templates';
import DocxToPdfTest from './pages/DocxToPdfTest';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Warehouse from './pages/Warehouse';
import Inventory from './pages/Inventory';
import Sales from './pages/Sales';
import Billing from './pages/Billing';
import Warranty from './pages/Warranty';
import Worksheets from './pages/Worksheets';
import Tasks from './pages/Tasks';
import Projects from './pages/Projects';
import ProjectBoard from './pages/ProjectBoard';
import ProjectsGantt from './pages/ProjectsGantt';
import Orders from './pages/Orders';
import DeliveryNotes from './pages/DeliveryNotes';
import PipelineView from './pages/PipelineView';
import EmailTest from './pages/EmailTest';
import NotificationSettingsPage from './pages/settings/NotificationSettings';
import FormBuilderPage from './pages/FormBuilder';
import FormBuilderEditor from './pages/FormBuilderEditor';
import FormFiller from './pages/FormFiller';
import PublicFormFiller from './pages/PublicFormFiller';
import EmbedFormFiller from './pages/EmbedFormFiller';
import CustomerFormFiller from './pages/CustomerFormFiller';
import SimpleCustomerFormFiller from './pages/SimpleCustomerFormFiller';
import PublicBookingPage from './components/appointments/PublicBookingPage';
import FormSubmissions from './pages/FormSubmissions';
import FormSubmissionsList from './pages/FormSubmissionsList';
import DocumentStorage from './pages/DocumentStorage';
import DocumentLibrary from './pages/DocumentLibrary';
import AIQuotationGenerator from './pages/AIQuotationGenerator';
import Reports from './pages/Reports';
import DocumentVariables from './pages/DocumentVariables';
import FlowBuilder from './pages/FlowBuilder';
import FlowDebug from './pages/FlowDebug';
import StorageOptimization from './pages/StorageOptimization';
import PublicCustomerRegistration from './pages/PublicCustomerRegistration';
import Notes from './pages/Notes';
import RichNotes from './pages/RichNotes';
import AppointmentBooking from './pages/AppointmentBooking';
import CustomerPortal from './pages/CustomerPortal';
import MissingItems from './pages/MissingItems';
import CustomerTickets from './pages/CustomerTickets';
import CustomerSignup from './pages/CustomerSignup';
import Subscriptions from './pages/Subscriptions';
import Leads from './pages/Leads';
import ProjectReports from './pages/ProjectReports';

export const router = createBrowserRouter([
  // Public routes
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/customer-signup/:token',
    element: <CustomerSignup />
  },
  {
    path: '/terms-of-service',
    element: <TermsOfService />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />
  },
  {
    path: '/quotations/public/:quotationId',
    element: <SharedQuotationView />
  },
  {
    path: '/shared/contracts/:contractId',
    element: <SharedContractView />
  },
  {
    path: '/forms/public/:publicId/fill',
    element: <PublicFormFiller />
  },
  {
    path: '/forms/embed/:publicId',
    element: <EmbedFormFiller />
  },
  {
    path: '/register/:organizationId',
    element: <PublicCustomerRegistration />
  },
  {
    path: '/book/:publicId',
    element: <PublicBookingPage />
  },
  // Protected routes
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <ProtectedRoute><DashboardModern /></ProtectedRoute>
      },
      {
        path: '/dashboard',
        element: <ProtectedRoute><DashboardModern /></ProtectedRoute>
      },
      {
        path: '/dashboard-old',
        element: <ProtectedRoute><Dashboard /></ProtectedRoute>
      },
      {
        path: '/customers',
        element: <ProtectedRoute requiredModule="customers"><Customers /></ProtectedRoute>
      },
      {
        path: '/customer-groups',
        element: <ProtectedRoute requiredModule="customers"><CustomerGroups /></ProtectedRoute>
      },
      {
        path: '/leads',
        element: <ProtectedRoute requiredModule="customers"><Leads /></ProtectedRoute>
      },
      {
        path: '/notes',
        element: <ProtectedRoute requiredModule="notes"><Notes /></ProtectedRoute>
      },
      {
        path: '/rich-notes',
        element: <ProtectedRoute requiredModule="notes"><RichNotes /></ProtectedRoute>
      },
            {
              path: '/document-storage',
              element: <ProtectedRoute requiredModule="customers"><DocumentLibrary /></ProtectedRoute>
            },
            {
              path: '/documents',
              element: <ProtectedRoute requiredModule="customers"><DocumentStorage /></ProtectedRoute>
            },
      {
        path: '/storage-optimization',
        element: <ProtectedRoute requiredModule="admin"><StorageOptimization /></ProtectedRoute>
      },
      {
        path: '/suppliers',
        element: <ProtectedRoute requiredModule="suppliers"><Suppliers /></ProtectedRoute>
      },
      {
        path: '/customer-relationship-logs',
        element: <ProtectedRoute requiredModule="customers"><CustomerRelationshipLogs /></ProtectedRoute>
      },
      {
        path: '/products',
        element: <ProtectedRoute requiredModule="products"><Products /></ProtectedRoute>
      },
      {
        path: '/categories',
        element: <ProtectedRoute requiredModule="products"><Categories /></ProtectedRoute>
      },
      {
        path: '/warehouse',
        element: <ProtectedRoute requiredModule="inventory"><Warehouse /></ProtectedRoute>
      },
      {
        path: '/inventory',
        element: <ProtectedRoute requiredModule="inventory"><Inventory /></ProtectedRoute>
      },
      {
        path: '/sales',
        element: <ProtectedRoute requiredModule="quotations"><Sales /></ProtectedRoute>
      },
      {
        path: '/warranty',
        element: <ProtectedRoute requiredModule="products"><Warranty /></ProtectedRoute>
      },
      {
        path: '/billing',
        element: <ProtectedRoute requiredModule="billing"><Billing /></ProtectedRoute>
      },
      {
        path: '/subscriptions',
        element: <ProtectedRoute requiredModule="billing"><Subscriptions /></ProtectedRoute>
      },
      {
        path: '/settings',
        element: <ProtectedRoute requiredModule="settings"><Settings /></ProtectedRoute>
      },
      {
        path: '/settings/notifications',
        element: <ProtectedRoute requiredModule="settings"><NotificationSettingsPage /></ProtectedRoute>
      },

      {
        path: '/ai-quotations',
        element: <ProtectedRoute requiredModule="quotations"><AIQuotationGenerator /></ProtectedRoute>
      },
      {
        path: '/quotations',
        element: <ProtectedRoute requiredModule="quotations"><Quotations /></ProtectedRoute>
      },
      {
        path: '/orders',
        element: <ProtectedRoute requiredModule="quotations"><Orders /></ProtectedRoute>
      },
      {
        path: '/delivery-notes',
        element: <ProtectedRoute requiredModule="quotations"><DeliveryNotes /></ProtectedRoute>
      },
      {
        path: '/pipeline',
        element: <ProtectedRoute requiredModule="quotations"><PipelineView /></ProtectedRoute>
      },
      {
        path: '/deals',
        element: <ProtectedRoute requiredModule="deals"><Deals /></ProtectedRoute>
      },
      {
        path: '/contracts',
        element: <ProtectedRoute requiredModule="contracts"><Contracts /></ProtectedRoute>
      },
      {
        path: '/templates',
        element: <ProtectedRoute requiredModule="templates"><Templates /></ProtectedRoute>
      },
      {
        path: '/document-variables',
        element: <ProtectedRoute requiredModule="templates"><DocumentVariables /></ProtectedRoute>
      },
      {
        path: '/form-builder',
        element: <ProtectedRoute requiredModule="forms"><FormBuilderPage /></ProtectedRoute>
      },
      {
        path: '/form-builder-editor',
        element: <ProtectedRoute requiredModule="forms"><FormBuilderEditor /></ProtectedRoute>
      },
      {
        path: '/forms',
        element: <ProtectedRoute requiredModule="forms"><FormSubmissions /></ProtectedRoute>
      },
      {
        path: '/forms/:templateId/fill',
        element: <ProtectedRoute requiredModule="forms"><FormFiller /></ProtectedRoute>
      },
      {
        path: '/form-submissions-list/:listId',
        element: <ProtectedRoute requiredModule="forms"><FormSubmissionsList /></ProtectedRoute>
      },
      {
        path: '/my-forms',
        element: <Navigate to="/form-builder?filter=my-templates" replace />
      },
      {
        path: '/worksheets',
        element: <ProtectedRoute requiredModule="worksheets"><Worksheets /></ProtectedRoute>
      },
      {
        path: '/tasks',
        element: <ProtectedRoute requiredModule="tasks"><Tasks /></ProtectedRoute>
      },
      {
        path: '/projects',
        element: <ProtectedRoute requiredModule="projects"><Projects /></ProtectedRoute>
      },
      {
        path: '/project-board',
        element: <ProtectedRoute requiredModule="projects"><ProjectBoard /></ProtectedRoute>
      },
      {
        path: '/projects-gantt',
        element: <ProtectedRoute requiredModule="projects"><ProjectsGantt /></ProtectedRoute>
      },
      {
        path: '/project-reports',
        element: <ProtectedRoute requiredModule="projects"><ProjectReports /></ProtectedRoute>
      },
      {
        path: '/reports',
        element: <ProtectedRoute requiredModule="projects"><Reports /></ProtectedRoute>
      },
      {
        path: '/flow-builder',
        element: <ProtectedRoute requiredModule="forms"><FlowBuilder /></ProtectedRoute>
      },
      {
        path: '/flow-debug',
        element: <ProtectedRoute requiredModule="forms"><FlowDebug /></ProtectedRoute>
      },
      {
        path: '/appointments',
        element: <ProtectedRoute requiredModule="appointments"><AppointmentBooking /></ProtectedRoute>
      },
      {
        path: '/customer-portal',
        element: <ProtectedRoute requiredModule="customerPortal"><CustomerPortal /></ProtectedRoute>
      },
      {
        path: '/customer-portal/forms/:templateId/fill',
        element: <ProtectedRoute requiredModule="customerPortal"><SimpleCustomerFormFiller /></ProtectedRoute>
      },
      {
        path: '/missing-items',
        element: <ProtectedRoute requiredModule="customerPortal"><MissingItems /></ProtectedRoute>
      },
      {
        path: '/customer-tickets',
        element: <ProtectedRoute requiredModule="customerPortal"><CustomerTickets /></ProtectedRoute>
      },
      {
        path: '/profile',
        element: <ProtectedRoute><ProfilePage /></ProtectedRoute>
      },
      {
        path: '/docx-to-pdf-test',
        element: <ProtectedRoute><DocxToPdfTest /></ProtectedRoute>
      },
      {
        path: '/email-test',
        element: <ProtectedRoute><EmailTest /></ProtectedRoute>
      },
      // System Admin routes
      {
        path: '/system-admin',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '/system-admin/overview',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '/system-admin/organizations',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '/system-admin/users',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '/system-admin/subscriptions',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '/system-admin/packages',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '/system-admin/modules',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '/system-admin/billing',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '/system-admin/payments',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '/system-admin/analytics',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '/system-admin/system',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '/system-admin/storage',
        element: <ProtectedRoute allowedRoles={['super_admin']} requiredModule="admin"><SystemAdmin /></ProtectedRoute>
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
]); 